var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparisonPowerButtonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5133_9574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66992 2.66099C7.43249 3.10126 8.02847 3.78084 8.36544 4.59434C8.70241 5.40784 8.76152 6.30979 8.53362 7.16031C8.30572 8.01084 7.80354 8.76239 7.10497 9.29842C6.40639 9.83445 5.55046 10.125 4.66992 10.125C3.78939 10.125 2.93345 9.83445 2.23488 9.29842C1.5363 8.76239 1.03412 8.01084 0.80622 7.16031C0.57832 6.30979 0.637438 5.40784 0.974405 4.59434C1.31137 3.78084 1.90736 3.10126 2.66992 2.66099M4.66992 0.5V5.20188",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5133_9574",
    x: 0.169922,
    y: 0,
    width: 9.5,
    height: 11.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.215686 0 0 0 0 0.905882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5133_9574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5133_9574",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonPowerButtonWhite);
export default __webpack_public_path__ + "static/media/ComparisonPowerButtonWhite.d2ef74a26f316a1cc3c9772736334167.svg";
export { ForwardRef as ReactComponent };